import React, { useState } from 'react'
import { Tab, Tabs } from '@mui/material'
import styles from './styles.module.css'
import LineChart from './LineChart'
import AreaChart from './AreaChart'

const LINE_CHART = 'Line Chart'
const AREA_CHART = 'Area Chart'

const BarCharts = (props) => {
  const { tab, isFullScreen } = props
  const [index, setIndex] = useState(tab ?? 0)
  const width = window.innerWidth / 2

  const handleChange = (event) => {
    const labelElement = event.target.innerHTML
    console.log('labelElement...', labelElement)
    if (labelElement.includes(LINE_CHART)) {
      setIndex(0)
    } else {
      setIndex(1)
    }
  }
  return (
    <div style={{ overflow: 'scroll' }}>
      {isFullScreen ? null : (
        <Tabs
          value={index}
          fullWidth
          onChange={handleChange}
          className={styles.tabContainer}
        >
          <Tab label={LINE_CHART} style={{ width, color: index==0 ? 'skyblue' : 'lightgray' }} />
          <Tab label={AREA_CHART} style={{ width, color: index==1 ? 'skyblue' : 'lightgray' }} />
        </Tabs>
      )}

      {index ? <AreaChart isMobile /> : <LineChart isMobile />}
    </div>
  )
}

export default BarCharts
